import MiSkeleton from './MiSkeleton.vue'

export default MiSkeleton
